import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../../utils/agent";
import * as API from "../../../utils/apiPath";

// -----------------------------
// LOAD MENTORS (REPLACES loadData)
// -----------------------------
export const loadMentorsList = createAsyncThunk(
  "mentorIgnite/loadMentorsList",
  async ({ request = {}, userId = 0, role = "Mentor", domains = "" }, { rejectWithValue }) => {
    try {
      const response = await agent.get(
        `${API.LOAD_SINDA_SHU}/${userId}/${role}?userDomains=${domains}`,
        { params: request }
      );

      const data = response?.data?.data || {};

      return {
        mentors: data.data || [],
        pagination: data.pagination || {},
        notFound: (data.data || []).length === 0,
      };
    } catch (error) {
      return rejectWithValue(error.message || "Failed to load mentors");
    }
  }
);

// -----------------------------
// SELECT MENTOR
// -----------------------------
export const saveSelectMentor = createAsyncThunk(
  "mentorIgnite/saveSelectMentor",
  async ({ userId, mentorId }, { rejectWithValue }) => {
    try {
      const res = await agent.post(API.SAVESELECTMENTOR, { userId, mentorId });
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// -----------------------------
// WAITLIST MENTOR
// -----------------------------
export const saveWaitlistMentor = createAsyncThunk(
  "mentorIgnite/saveWaitlistMentor",
  async ({ userId, mentorId }, { rejectWithValue }) => {
    try {
      const res = await agent.post(API.SAVEWAITLISTMENTOR, { userId, mentorId });
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// -----------------------------
// LOAD PROGRAMMES
// -----------------------------
export const loadProgrammes = createAsyncThunk(
  "mentorIgnite/loadProgrammes",
  async (_, { rejectWithValue }) => {
    try {
      const res = await agent.get(API.LOAD_PROGRAMMES + "/all");
      return res.data?.data || [];
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const mentorIgniteSlice = createSlice({
  name: "mentorIgnite",
  initialState: {
    mentorsData: [],
    pagination: {},
    programmes: [],
    loading: false,
    notFound: false,
    error: null,
    lastMessage: "",
  },

  reducers: {},

  extraReducers: (builder) => {
    builder
      // LOAD MENTORS
      .addCase(loadMentorsList.pending, (state) => {
        state.loading = true;
      })
      .addCase(loadMentorsList.fulfilled, (state, action) => {
        state.loading = false;
        state.mentorsData = action.payload.mentors;
        state.pagination = action.payload.pagination;
        state.notFound = action.payload.notFound;
      })
      .addCase(loadMentorsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.notFound = true;
      })

      // SELECT MENTOR
      .addCase(saveSelectMentor.fulfilled, (state, action) => {
        state.lastMessage = action.payload?.message;
      })

      // WAITLIST
      .addCase(saveWaitlistMentor.fulfilled, (state, action) => {
        state.lastMessage = action.payload?.message;
      })

      // PROGRAMMES
      .addCase(loadProgrammes.fulfilled, (state, action) => {
        state.programmes = action.payload;
      });
  },
});

export default mentorIgniteSlice.reducer;
